// @flow

import * as React from 'react';
import ReactDOM from 'react-dom';

type Props = {
  children: React.Node,
};

/**
 * Renders children in a React Portal on document.body
 */
class Portal extends React.Component<Props> {
  node = null;

  UNSAFE_componentWillMount() {
    this.node = document.createElement('div');
    const body = document.body;
    if (!body) return;
    body.appendChild(this.node);
  }

  componentWillUnmount() {
    const body = document.body;
    if (!body || !this.node) return;
    body.removeChild(this.node);
  }

  render() {
    const { children } = this.props;
    const { node } = this;
    return node ? ReactDOM.createPortal(children, node) : null;
  }
}

export default Portal;
